import serpFiltersModal from "./filtersModal";
import {MitulaSerpPageData} from "../SerpPage";
import {EventBus} from "../../../../common/ts/events/EventBus";
import eventHandlers from "./eventHandlers";
import {isDesktopDevice} from "../../device";
import operationTypeSelect from "../../components/userSearch/operationTypeSelect";
import dom from "../../../../common/ts/core/dom";
import location from "../../../../common/ts/core/location";
import propertyTypeSelect from "../../components/userSearch/propertyTypeSelect";
import {FiltersSubmittedEvent} from "./events";
import tracking from "../../../../common/ts/core/tracking";
import {getFormDataSubmittingInFilterBar, getTrackingFormData} from "./filterFormData";
import {FILTERS_BAR_FORM_SELECTOR} from "../../../../common/ts/serp/filters/constants";
import {WlSubmit} from "../../../../common/ts/webcomponents/events/WlSubmit";
import {FILTER_NAMES} from "../../../../common/ts/serp/filters/constants";
import freeTextInputFilterComponent from "./freeTextInput/freeTextInputFilterComponent";
import geoChildrenSelectorFiltersComponent from "./geoChildrenSelectorFiltersComponent";
const eventBus: EventBus = EventBus.getInstance();


function init(pageData: MitulaSerpPageData) {
    eventHandlers.init();
    serpFiltersModal.init(eventBus, pageData);
    freeTextInputFilterComponent.init();
    geoChildrenSelectorFiltersComponent.init(pageData.pageviewId);
    registerSubmitButtonFiltersListener(pageData);
    subscribeSubmitForDropDownFilters();
}

function emitSubmit (e: CustomEvent) {
    e.preventDefault();
    const searchParams = new URLSearchParams(location.getQueryParams());
    const formData = getFormDataSubmittingInFilterBar()

    eventBus.emitMany([
        new FiltersSubmittedEvent({
            formData,
            searchParams,
            type: FiltersSubmittedEvent.FORM_TYPE
        }),
        new tracking.TrackWebTrackingEvent({
            type: "FiltersUpdated",
            serpUrl: window.location.href,
            filters: getTrackingFormData(formData, searchParams)
        })
    ])
}

function subscribeSubmitForDropDownFilters() {
    const filtersBarForm = dom.select(FILTERS_BAR_FORM_SELECTOR) as HTMLFormElement;

    filtersBarForm.querySelectorAll(".js_filter_submit")
        .forEach((element: Node) => (element as HTMLElement).addEventListener(WlSubmit.type, emitSubmit as EventListener))

}

function registerSubmitButtonFiltersListener(pageData: MitulaSerpPageData) {
    eventBus.emit(new dom.AddClickListenerEvent({
       selector: "#priceRangeFilter_apply",
        listener: emitSubmit
    }));

    eventBus.emit(new dom.AddClickListenerEvent({
        selector: ".js_free-text-submit-button",
        listener: emitSubmit
    }));

    if (isDesktopDevice(pageData.device)) {
        operationTypeSelect.init(FILTERS_BAR_FORM_SELECTOR);
        propertyTypeSelect.init(pageData.propertyType);
    }
}

export default {
    init,
}
